import Cookies from "js-cookie"
import { authRedirectTargetUrl } from "@store/services/authQuery"
import { downloadFile } from "utils/file"

export const downloadRunResultData = (runId: string): Promise<undefined> => {
  const errorMessage = `Problem with downloading results for ${runId}`
  // Results downloader - due to file size might exceed 1gb that is javascript string limit download as blob
  return new Promise((resolve, reject) => {
    const userToken = Cookies.get("User")
    fetch(`${import.meta.env.VITE_APP_API_URL}/api/v1/runs/${runId}/download`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    })
      .then((r) => {
        if (r.status === 401) {
          authRedirectTargetUrl()
          reject(errorMessage)
        }
        return r.blob()
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob)
        downloadFile(`pgm-results-all-${runId}`, url)
        URL.revokeObjectURL(url)
        resolve(undefined)
      })
  })
}
